// ... existing imports ...
import { FulfillmentStatus, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocDisplayType, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

// ... existing code ...

const fulfRoot = `${SYSTEM_ENUM_ROOT}|Fulfillment Status`;

export type CPFulfillmentStatusLocs =
	| 'CPFulfillmentStatusEnumFailed'
	| 'CPFulfillmentStatusEnumCompleted'
	| 'CPFulfillmentStatusEnumPending'
	| 'CPFulfillmentStatusEnumPendingExpired'
	| 'CPFulfillmentStatusEnumQueued'
	| 'CPFulfillmentStatusEnumOrdered'
	| 'CPFulfillmentStatusEnumAvailable'
	| 'CPFulfillmentStatusEnumNever';

export type SPFulfillmentStatusLocs =
	| 'SPFulfillmentStatusEnumFailed'
	| 'SPFulfillmentStatusEnumCompleted'
	| 'SPFulfillmentStatusEnumPending'
	| 'SPFulfillmentStatusEnumPendingExpired'
	| 'SPFulfillmentStatusEnumQueued'
	| 'SPFulfillmentStatusEnumOrdered'
	| 'SPFulfillmentStatusEnumAvailable'
	| 'SPFulfillmentStatusEnumNever';

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.CredentialFulfillment,
};

export const cpFulfillmentStatusEnumLocs: LocDefs<CPFulfillmentStatusLocs> = {
	CPFulfillmentStatusEnumFailed: {
		defaultValue: 'Failed',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Failed}`,
		description: `System value for '${FulfillmentStatus.Failed}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumCompleted: {
		defaultValue: 'Completed',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Completed}`,
		description: `System value for '${FulfillmentStatus.Completed}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumPending: {
		defaultValue: 'Pending',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Pending}`,
		description: `System value for '${FulfillmentStatus.Pending}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumPendingExpired: {
		defaultValue: 'Pending Expired',
		displayPath: `${fulfRoot}|${FulfillmentStatus.PendingExpired}`,
		description: `System value for '${FulfillmentStatus.PendingExpired}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Queued}`,
		description: `System value for '${FulfillmentStatus.Queued}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumOrdered: {
		defaultValue: 'Ordered',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Ordered}`,
		description: `System value for '${FulfillmentStatus.Ordered}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumAvailable: {
		defaultValue: 'Available',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Available}`,
		description: `System value for '${FulfillmentStatus.Available}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
	CPFulfillmentStatusEnumNever: {
		defaultValue: 'Never',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Never}`,
		description: `System value for '${FulfillmentStatus.Never}' fulfillment status`,
		portal: 'CP',
		...sharedLocData,
	},
};

export const spFulfillmentStatusEnumLocs: LocDefs<SPFulfillmentStatusLocs> = {
	SPFulfillmentStatusEnumFailed: {
		defaultValue: 'Failed',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Failed}`,
		description: `System value for '${FulfillmentStatus.Failed}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumCompleted: {
		defaultValue: 'Completed',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Completed}`,
		description: `System value for '${FulfillmentStatus.Completed}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumPending: {
		defaultValue: 'Pending',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Pending}`,
		description: `System value for '${FulfillmentStatus.Pending}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumPendingExpired: {
		defaultValue: 'Pending - Expired',
		displayPath: `${fulfRoot}|${FulfillmentStatus.PendingExpired}`,
		description: `System value for '${FulfillmentStatus.PendingExpired}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Queued}`,
		description: `System value for '${FulfillmentStatus.Queued}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumOrdered: {
		defaultValue: 'Ordered',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Ordered}`,
		description: `System value for '${FulfillmentStatus.Ordered}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumAvailable: {
		defaultValue: 'Available',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Available}`,
		description: `System value for '${FulfillmentStatus.Available}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
	SPFulfillmentStatusEnumNever: {
		defaultValue: 'Never',
		displayPath: `${fulfRoot}|${FulfillmentStatus.Never}`,
		description: `System value for '${FulfillmentStatus.Never}' fulfillment status`,
		portal: 'SP',
		...sharedLocData,
	},
};

export const FULFILLMENT_STATUS_ENUM_LOCS = MapLocKeys<
	CPFulfillmentStatusLocs | SPFulfillmentStatusLocs
>({
	...cpFulfillmentStatusEnumLocs,
	...spFulfillmentStatusEnumLocs,
});

export type CPFulfillmentStatusEnumLocType = LocMap<CPFulfillmentStatusLocs>;
export type SPFulfillmentStatusEnumLocType = LocMap<SPFulfillmentStatusLocs>;

export const cpFulfillmentStatusKeys: {
	[key in FulfillmentStatus]: keyof CPFulfillmentStatusEnumLocType;
} = {
	Failed: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumFailed,
	Completed: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumCompleted,
	Pending: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumPending,
	PendingExpired: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumPendingExpired,
	Queued: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumQueued,
	Ordered: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumOrdered,
	Available: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumAvailable,
	Never: FULFILLMENT_STATUS_ENUM_LOCS.CPFulfillmentStatusEnumNever,
};

export const spFulfillmentStatusKeys: {
	[key in FulfillmentStatus]: keyof SPFulfillmentStatusEnumLocType;
} = {
	Failed: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumFailed,
	Completed: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumCompleted,
	Pending: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumPending,
	PendingExpired: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumPendingExpired,
	Queued: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumQueued,
	Ordered: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumOrdered,
	Available: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumAvailable,
	Never: FULFILLMENT_STATUS_ENUM_LOCS.SPFulfillmentStatusEnumNever,
};
